import React, { FC } from 'react';

import Chip from '@mui/material/Chip';

// ServMan order statuses (ORDSTS). Coordinator-set statuses get solid colors;
// technician mobile statuses (EnRoute/OnSite/T_*) get muted ones.
const STATUS_COLORS: Record<string, { backgroundColor: string; color: string }> = {
  Open: { backgroundColor: '#e3f2fd', color: '#1565c0' },
  Acknowledge: { backgroundColor: '#fff3e0', color: '#e65100' },
  Confirmed: { backgroundColor: '#e0f2f1', color: '#00695c' },
  Complete: { backgroundColor: '#e8f5e9', color: '#2e7d32' },
  Incomplete: { backgroundColor: '#ffebee', color: '#c62828' },
  EnRoute: { backgroundColor: '#ede7f6', color: '#4527a0' },
  OnSite: { backgroundColor: '#e8eaf6', color: '#283593' },
  T_Incomplete: { backgroundColor: '#fbe9e7', color: '#bf360c' },
};

const DEFAULT_COLORS = { backgroundColor: '#eceff1', color: '#455a64' };

interface OrderStatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

const OrderStatusChip: FC<OrderStatusChipProps> = ({ status, size = 'small' }) => {
  const colors = STATUS_COLORS[status] || DEFAULT_COLORS;

  return <Chip label={status} size={size} sx={{ ...colors, fontWeight: 600 }} />;
};

export default OrderStatusChip;
